/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_No_RegistrationInputs */



/**
* | output |
* | --- |
* | "Can I run an event without ever opening registration?" |
*
* @param {Og_Faq_Q_No_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_no_registration = /** @type {((inputs?: Og_Faq_Q_No_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_No_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Puis-je organiser un événement sans jamais ouvrir les inscriptions ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Puedo organizar un evento sin abrir nunca la inscripción?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Posso realizar um evento sem nunca abrir as inscrições?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posso organizzare un evento senza mai aprire le iscrizioni?")
	return /** @type {LocalizedString} */ ("Can I run an event without ever opening registration?")
});